<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal modal-sm alert" style="background-color: #f9f9f9;">
				<div class="modal-header p-0 clearfix" style="background-color: #f9f9f9;">
					<a class="close" @click="config.show = false">×</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body m-t-15 p-0 clearfix">
					<table class="table2 m-t-0">
						<tbody>
							<tr>
								<td class="round">학생들을 배려해주는 언어 사용</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
								예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
								예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
								예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
									예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
									예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
									예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
									예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
							<tr class="margin">
								<td></td>
							</tr>
							<tr>
								<td class="round">예시를 풍부하게 들어주고 전달력이 좋습니다. 예시를 풍부하게 들어주고 전달력이 좋습니다.
									예시를 풍부하게 들어주고 전달력이 좋습니다.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- //end .modal-body -->
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalClassSurveyResult",

	default: function() {
		return {
			show: false
		}
	},
	data (){
		return  {

		}
	},

	props: {
		config: Object
	}
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
td {white-space: normal !important;}
</style>